import React from 'react';
import { useTranslation } from 'react-i18next';
import { UnifiedCard } from '../../components';
import { Routes } from '../../routes';
import { useAllInterviewsCompleted } from '../../hooks/useAllInterviewsCompleted';
import { computeHomeProcessDisplayStatus } from '../../utils/processHomeStatus';
import type { iProcess } from '../../components/type';

export type ProcessLibraryCardProps = {
    proc: iProcess;
    index: number;
    hasNotif: boolean;
    ownerLabel: string;
    deleProcess: (process_id: string, title?: string) => void | Promise<void>;
    updateProcess: (newData: unknown) => void;
    updateProject?: (newData: unknown) => void;
};

const ProcessLibraryCard: React.FC<ProcessLibraryCardProps> = ({
    proc,
    index,
    hasNotif,
    ownerLabel,
    deleProcess,
    updateProcess,
    updateProject,
}) => {
    const { t } = useTranslation();
    const allDone = useAllInterviewsCompleted(proc._id);
    const processStatus = computeHomeProcessDisplayStatus(hasNotif, allDone);

    return (
        <UnifiedCard
            key={proc._id}
            variant="library"
            index={index}
            processName={proc.title}
            processStatus={processStatus}
            thisProcessHasABadge={hasNotif}
            theBadgeHasAValue={false}
            badgeValue={0}
            thisProcessHasAOwner={true}
            owner={ownerLabel}
            route={Routes.PROCESS_INTERVIEW}
            deleteProcess={() => deleProcess(proc._id, proc.title)}
            description={proc.description}
            processId={proc._id}
            folder={false}
            setProject={updateProject ?? (() => {})}
            setProcess={updateProcess}
            elementType="process"
            updatedAt={proc.updated_at}
            createdAt={proc.created_at}
            processSnapshot={proc as unknown as Record<string, unknown>}
            t={t}
        />
    );
};

export default ProcessLibraryCard;
